// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#batch-copy{height:100vh;overflow-y:hidden}#batch-copy-form{height:calc(100vh - 110px);overflow-y:auto}#batch-copy .v-list--three-line .v-list__tile{height:auto!important}", ""]);
// Exports
module.exports = exports;
